/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLocaleCtx } from "@/contexts/locale";

export function SubjectSelector({ setSubject, subjects }: any) {
  const { lang } = useLocaleCtx();
  return (
    <Select dir={lang === "en" ? "ltr" : "rtl"} onValueChange={(value) => setSubject(value)}>
      <SelectTrigger className="min-w-[240px] rounded-full bg-foreground p-6 font-opensans text-secondary/90 backdrop-blur-md">
        <SelectValue placeholder={lang === "en" ? "All Subjects" : "جميع المواضيع"} />
      </SelectTrigger>
      <SelectContent className="bg-foreground text-secondary opacity-100">
        <SelectGroup>
          <SelectItem value=" ">{lang === "en" ? "All Subjects" : "جميع المواضيع"}</SelectItem>
          {subjects.map((sub: any, index: number) => (
            <SelectItem key={index} value={sub.value}>
              {sub.title}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
